import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { automations } from 'modules/automations/store/collections/automations'
import type { Automation } from 'modules/automations/store/models/Automation'

interface Props {
  automationId: string
  onSuccess: () => void
  onClose: () => void
}

const DeleteAutomationModal = ({ automationId, onClose, onSuccess }: Props) => {
  const automation = React.useMemo<Automation>(() => {
    const automation = automations.find({
      id: automationId,
    })

    if (!automation) {
      throw new Error(`Missing automation with id: ${automationId}`)
    }

    return automation
  }, [automationId])

  const onSubmit = async (closePortal: ClosePortalFn) => {
    const { success } = await asyncAction(() => automation.destroy())

    if (success) {
      closePortal({
        preventOnCloseCallbackAfterClose: true,
      })
      onSuccess()
    }
  }

  return (
    <Modal
      illustration="delete-cross"
      title={i18n.t('automations.automation.delete.title')}
      description={i18n.t('automations.automation.delete.description')}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <Button type="negative" submit>
          {i18n.t('common.destroy')}
        </Button>
      }
    />
  )
}

export default DeleteAutomationModal
